import { PublicNav } from "@/components/layout/public-nav";
import { LegalFooterLinks } from "@/components/legal-footer"; // Let's keep a simplified footer

export function PublicLayoutWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-[#0B0D10] text-[#F5F6F7]">
      <PublicNav />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
      <footer className="border-t border-white/5 py-8 mt-12 bg-[#0B0D10]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <LegalFooterLinks />
        </div>
      </footer>
    </div>
  );
}
